import {
  flexRender,
} from "@tanstack/react-table"


import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/table"

import { DataTablePagination } from "./DataTablePagination"

import { useTableDataColumn } from "@univdiam/ui/lib/TableDataColumn"
import { getColumns } from "./columns"
import type { TableViewProps } from "@univdiam/ui/lib/SharedTypes"
import { useMemo } from "react"



export function DataTable({
  data,
  globalFilter,
  // setGlobalFilter,
  sorting,
  setSorting,
  columnVisibility,
  setColumnVisibility,
  handleOrderOpen,
  isAdmin,
  onUpdateOrder,
  adminTags = [],
  fetchTags,
  page,
  setPage,
  pagination
}: TableViewProps & { page?: number, setPage?: any, pagination?: any }) {

  const columns = useMemo(() => getColumns(isAdmin, onUpdateOrder, adminTags, fetchTags), [isAdmin, onUpdateOrder, adminTags, fetchTags])
  // `data` is already filtered by the caller (search/tag filter); don't re-filter
  // it here or react-table's default global filter drops rows it can't match.
  const table = useTableDataColumn(data, columns, setSorting, setColumnVisibility, "", sorting, columnVisibility)

  return (
    <div>
      <Table>
        <TableHeader className="bg-[#ffffff]">
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <TableHead key={header.id} className="px-5 py-4 text-left">
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                  </TableHead>
                )
              })}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.length ? (
            table.getRowModel().rows.map((row) => (
              <TableRow
                onClick={() => {
                  handleOrderOpen(row.original.id.toString(), row.original.customer_id.toString(), row.original.order_id)
                }}
                key={row.id}
                className={`${row.original.is_new_update ? "bg-white font-semibold text-body2-semibold" : "bg-[#F7F7F8] "
                  } hover:bg-[#883734]/10 cursor-pointer transition-colors duration-200`}
              >
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id} className="px-5 py-4 text-left ">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="h-24 text-center">
                No results.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <DataTablePagination table={table} page={page} setPage={setPage} pagination={pagination} />
    </div>
  )
}